import { makeStyles } from '@material-ui/styles';
import { translateColorByRedeId } from '../../colors';

export const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    height: 30,
    width: 30,
    marginTop: "1rem",
    borderRadius: "0 3px 3px 0",
    backgroundColor: ({ redeId }) => translateColorByRedeId(redeId)
  },
  index: {
    fontSize: "1.25rem",
    fontWeight: "700",
    color: "#FFF"
  }
});